module.exports = __webpack_public_path__ + "media/charts/DesignEmployment-d942bdf8.svg";